import React, { useState, useEffect, useMemo } from "react";
import { Button, Field, Groupper, Header, Input, Message } from "react-frontier2";
import { SetLoading, ShortUser } from "@arema/components/Classes";
import { bindClick, bindFormChange } from "@arema/components/Util";
import { useTranslation } from "react-i18next";
import { useUser } from "../../AdminHooks";
import { SearchUserModal } from "../../components";
import API from "../../API";
import Validator from "@arema/components/Validator";
import SearchCoreDropdown from "../../components/SearchCoreDropdown";
import UserAccess from "../../UserAccess";
import { useFrontier } from "react-frontier2";

interface Promoter {
	promoter_id?: number,
	promoter_name: string,
	user_assigned: number,
	user_assigned_name: string,
	service_id?: number,
}

interface Props {
	promoter?: Promoter,
	promoter_id?: number,
	onEditPromoter?: (p: Promoter)=>void,
}

enum Modals{
	CHANGE_ASSIGNED = 1,
}

const PromoterView = (props: Props)=>{
	var { t } = useTranslation();
	var { hasAccess } = useUser();
	var { Toast } = useFrontier();
	var [shownModal, setShownModal] = useState<Modals>(null);
	var [promoter, setPromoter] = useState<Promoter>(props.promoter);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);

	var ACCESS = useMemo(()=>{
		return {
			service: hasAccess(UserAccess.CATALOGS.PROMOTER_EDIT_SERVICE),
		}
	}, []);

	const submit = async (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(promoter, {
			promoter_name: [{
				rule: 'length', params: [4, 128], label: 'Nombre'
			}],
		});
		setErrorPrompts(prompts);
		if (!valid) return;
		setLoading(true);
		API.editPromoter(promoter.promoter_id, {
			promoter_name: promoter.promoter_name,
			service_id: ACCESS.service ? promoter.service_id : undefined,
		}).then(res=>{
			if (res.error) return setErrorPrompts([res.message]);
			Toast.success('Se ha editado el promotor.');
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado editando el promotor (LCL-11)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var changeAssigned = (user: ShortUser)=>{
		setShownModal(null);
		if(user.user_id===promoter.user_assigned) return;
		var tx = Toast.show(t('toasts.saving_info'), { loading: true });
		API.setPromoterUserAssigned(promoter.promoter_id, user.user_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			var new_p = {
				...promoter,
				user_assigned: user.user_id,
				user_assigned_name: user.name,
			}
			setPromoter(new_p);
			if(props.onEditPromoter) props.onEditPromoter(new_p);
			Toast.success(t('common.changes_saved'))
		}).catch(err=>{
			Toast.error(t('common.unexpected_code', { code: 'LCL-PRCHASN-1' }));
		}).finally(()=>{
			Toast.dismiss(tx);
		})
	}

	var onChangeField = bindFormChange(promoter, setPromoter);

	return (
		<div>
			<Groupper title={t('promoter_edit.title')} style={{ maxWidth: 600 }} actions={(
				<Button text={t('common.save')} color="black" onClick={submit} />
			)}>
				<Input label={t('promoter_edit.form.name')} value={promoter.promoter_name} onChange={onChangeField('promoter_name')} />
				{!!ACCESS.service && (
					<SearchCoreDropdown
						label={t('promoter_edit.form.service')}
						value={promoter.service_id}
						onValueChange={onChangeField('service_id')}
						onShowLoad={()=>{
							return API.getAcquirerService();
						}}
						searchData={q=>{
							return API.getAcquirerService(q);
						}}
						renderItem={a=>({
							text: a.service_name,
							value: a.service_id,
							meta: `ID: ${a.service_id}`,
						})}
					/>
				)}
				<Field label="Asignado">
					<Input value={promoter.user_assigned_name} placeholder={'Usuario asignado'} buttons={(
						<Button text="Cambiar" onClick={bindClick(setShownModal, Modals.CHANGE_ASSIGNED)} />
					)} />
				</Field>
				<Message list={errorPrompts} type="error" style={{ marginTop: 15 }} />
			</Groupper>
			<SearchUserModal
				open={shownModal===Modals.CHANGE_ASSIGNED}
				onSelected={changeAssigned}
				onClose={bindClick(setShownModal)}
			/>
		</div>
	)
}

export default PromoterView;